import "@fontsource/italiana/400.css"
import "@fontsource-variable/space-grotesk"
import "lenis/dist/lenis.css"
import "./src/styles/global.css"

import { bodyClassForPath } from "./src/utils/theme"

/** Keep the <body> ground in step with the route on client-side navigation. */
export const onRouteUpdate = ({ location }) => {
  const next = bodyClassForPath(location.pathname)
  document.body.classList.remove("theme-light", "theme-dark")
  document.body.classList.add(next)
}
